const desktopLanguage: Record<string, Record<string, string>> = {
  'en-US': {
    meeting_resize_panels: 'Resize meeting content and Edit & QA panels',
    meeting_detail_tab_summary: 'Summary',
    meeting_detail_tab_summary_editor: 'Edit & QA',
    record_ready: 'Ready when you are',
    record_active: 'Recording in progress',
    record_paused: 'Recording paused',
    record_saved: 'Recording saved',
    record_empty_hint: 'Record a meeting to continue · 1 credit per minute',
    upload_recording_title: 'Upload a recording',
    upload_recording_description: 'Audio or video from a meeting. Transcription takes about 10–15 minutes for every hour of recording.',
    upload_breadcrumb: 'Breadcrumb',
    upload_drop_here: 'Drag a file here or',
    upload_browse: 'Browse files',
    upload_limits: 'Audio up to 600 MB · Video up to 500 MB',
    upload_details: 'Meeting details',
    upload_title_label: 'Meeting title',
    upload_notes_label: 'Notes',
    upload_optional: 'Optional',
    upload_notes_placeholder: 'Agenda, attendees, or anything else worth keeping with this meeting',
    upload_name_hint: 'Filled in from the file name — edit it if you like',
    upload_empty_hint: 'Add a file to continue · 1 credit per minute',
    upload_pending_hint: 'Start once the upload finishes · uses {credits} credits',
    upload_pending_hint_one: 'Start once the upload finishes · uses 1 credit',
    upload_preparing_hint: 'Preparing your file…',
    upload_ready_hint: 'Ready to transcribe · uses {credits} credits',
    upload_ready_hint_one: 'Ready to transcribe · uses 1 credit',
    upload_failed_hint: 'Upload failed. Replace or remove the file to continue.',
    upload_start: 'Start transcription',
    upload_replace: 'Replace',
    upload_remove: 'Remove',
    upload_audio: 'Audio',
    upload_video: 'Video',
    upload_duration_minutes: '{minutes} min',
    upload_duration_seconds: '{seconds} s',
    upload_status_progress: 'Uploading · {percent}%',
    upload_status_complete: 'Upload complete',
    upload_status_failed: 'Upload failed',
    upload_transferred: '{transferred} of {total} {unit}',
    upload_time_left: 'about {seconds} s left',

    desktop_share_title: 'Shared transcription',
    desktop_share_waiting: 'Waiting for the conversation…',
    desktop_share_demo: 'Demo transcript',
    desktop_share_ended: 'The meeting has ended.',
    desktop_share_connection_error: 'Connection unavailable. Showing demo data.',
    desktop_share_invalid: 'Invalid session.',
    desktop_field_email: 'Email address',
    desktop_field_password: 'Password',
    desktop_field_name: 'Name',
    desktop_field_confirm_password: 'Confirm password',
    desktop_field_verification: 'Verification code',
    desktop_field_new_password: 'New password',
    desktop_field_invitation: 'Invitation code',
    theme_dark_mode: 'Dark mode',
    theme_switch_light: 'Switch to light mode',
    theme_switch_dark: 'Switch to dark mode',
    home_good_morning: 'Good morning',
    home_good_afternoon: 'Good afternoon',
    home_good_evening: 'Good evening',
    home_days_active: 'days active',
    home_transcribed: 'transcribed',
    home_transcriptions: 'transcriptions',
    home_start_recording: 'Start recording',
    home_upload_file: 'Upload file',
    home_upload_short: 'Upload',
    home_record_short: 'Record',
    home_transcribe_short: 'Transcribe',
    home_live_transcribe: 'Live transcribe',
    home_create_meeting: 'Create a meeting',
    home_recent_meetings: 'Recent meetings',
    home_view_all: 'View all',
    home_more_actions: 'More actions',
    home_untitled_meeting: 'Untitled meeting',
    home_retry_hint: 'Ready to retry',
    home_summary_ready: 'Summary ready',
    home_summary_failed: 'Summary unavailable',
    home_stats_error: 'Could not load your statistics.',
    home_meetings_error: 'Could not load your meetings. Please try again.',
    home_empty_title: 'Your next meeting starts here',
    home_empty_description: 'Record a conversation or upload a file to create your first meeting.',
    sidebar_hot_words: 'Custom Vocabulary',
    sidebar_all_chat: 'Chat history',
    hot_words_title: 'Custom vocabulary',
    desktop_upload_description: 'Turn an audio or video file into a transcript and meeting notes.',
    desktop_record_description: 'Capture your conversation. We’ll take care of the notes.',
    desktop_live_description: 'Follow the conversation with live transcription and translation.',
    desktop_not_found_title: 'This page could not be found',
    desktop_not_found_description: 'Check the address or return to your workspace.',
    desktop_back_home: 'Back to home',
  },
  'zh-HK': {
    meeting_resize_panels: '調整會議內容和編輯與問答面板寬度',
    meeting_detail_tab_summary: '總結',
    meeting_detail_tab_summary_editor: '編輯&問答',
    record_ready: '準備好即可開始',
    record_active: '正在錄音',
    record_paused: '錄音已暫停',
    record_saved: '錄音已儲存',
    record_empty_hint: '錄製會議以繼續 · 每分鐘 1 積分',
    upload_recording_title: '上載錄音',
    upload_recording_description: '上載會議的音訊或影片。每小時的錄音約需 10–15 分鐘完成轉寫。',
    upload_breadcrumb: '導覽路徑',
    upload_drop_here: '將檔案拖放至此，或',
    upload_browse: '瀏覽檔案',
    upload_limits: '音訊上限 600 MB · 影片上限 500 MB',
    upload_details: '會議詳情',
    upload_title_label: '會議標題',
    upload_notes_label: '備註',
    upload_optional: '選填',
    upload_notes_placeholder: '議程、與會者，或其他需要保留的會議資訊',
    upload_name_hint: '已根據檔案名稱填入，您可隨時修改',
    upload_empty_hint: '加入檔案以繼續 · 每分鐘 1 積分',
    upload_pending_hint: '上載完成後即可開始 · 將使用 {credits} 積分',
    upload_preparing_hint: '正在準備檔案…',
    upload_ready_hint: '準備好轉寫 · 將使用 {credits} 積分',
    upload_failed_hint: '上載失敗，請更換或移除檔案以繼續。',
    upload_start: '開始轉寫',
    upload_replace: '更換',
    upload_remove: '移除',
    upload_audio: '音訊',
    upload_video: '影片',
    upload_duration_minutes: '{minutes} 分鐘',
    upload_duration_seconds: '{seconds} 秒',
    upload_status_progress: '上載中 · {percent}%',
    upload_status_complete: '上載完成',
    upload_status_failed: '上載失敗',
    upload_transferred: '已上載 {transferred} / {total} {unit}',
    upload_time_left: '約剩 {seconds} 秒',

    desktop_share_title: '共享轉寫',
    desktop_share_waiting: '等待對話開始…',
    desktop_share_demo: '示範轉寫',
    desktop_share_ended: '會議已結束。',
    desktop_share_connection_error: '無法連線，正顯示示範資料。',
    desktop_share_invalid: '無效的會話。',
    desktop_field_email: '電郵地址',
    desktop_field_password: '密碼',
    desktop_field_name: '姓名',
    desktop_field_confirm_password: '確認密碼',
    desktop_field_verification: '驗證碼',
    desktop_field_new_password: '新密碼',
    desktop_field_invitation: '邀請碼',
    theme_dark_mode: '深色模式',
    theme_switch_light: '切換至淺色模式',
    theme_switch_dark: '切換至深色模式',
    home_good_morning: '早晨',
    home_good_afternoon: '午安',
    home_good_evening: '晚上好',
    home_days_active: '使用天數',
    home_transcribed: '已轉寫時長',
    home_transcriptions: '次轉寫',
    home_start_recording: '開始錄音',
    home_upload_file: '上載檔案',
    home_upload_short: '上載',
    home_record_short: '錄音',
    home_transcribe_short: '轉寫',
    home_live_transcribe: '即時轉寫',
    home_create_meeting: '建立會議',
    home_recent_meetings: '最近會議',
    home_view_all: '查看全部',
    home_more_actions: '更多操作',
    home_untitled_meeting: '未命名會議',
    home_retry_hint: '可重新嘗試',
    home_summary_ready: '摘要已就緒',
    home_summary_failed: '摘要無法產生',
    home_stats_error: '未能載入統計資料。',
    home_meetings_error: '未能載入會議，請重試。',
    home_empty_title: '從這裏開始下一場會議',
    home_empty_description: '錄製對話或上載檔案，建立您的第一場會議。',
    sidebar_hot_words: '自訂詞彙',
    sidebar_all_chat: '對話記錄',
    hot_words_title: '自訂詞彙',
    desktop_upload_description: '將音訊或影片檔案轉換為逐字稿與會議筆記。',
    desktop_record_description: '錄下對話，讓我們為您整理筆記。',
    desktop_live_description: '透過即時轉寫與翻譯，緊貼每段對話。',
    desktop_not_found_title: '找不到此頁面',
    desktop_not_found_description: '請檢查網址，或返回您的工作區。',
    desktop_back_home: '返回首頁',
  },
  'zh-CN': {
    meeting_resize_panels: '调整会议内容和编辑与问答面板宽度',
    meeting_detail_tab_summary: '总结',
    meeting_detail_tab_summary_editor: '编辑&问答',
    record_ready: '准备好即可开始',
    record_active: '正在录音',
    record_paused: '录音已暂停',
    record_saved: '录音已保存',
    record_empty_hint: '录制会议以继续 · 每分钟 1 积分',
    upload_recording_title: '上传录音',
    upload_recording_description: '上传会议的音频或视频。每小时的录音约需 10–15 分钟完成转写。',
    upload_breadcrumb: '导航路径',
    upload_drop_here: '将文件拖放至此，或',
    upload_browse: '浏览文件',
    upload_limits: '音频上限 600 MB · 视频上限 500 MB',
    upload_details: '会议详情',
    upload_title_label: '会议标题',
    upload_notes_label: '备注',
    upload_optional: '选填',
    upload_notes_placeholder: '议程、参会者，或其他需要保留的会议信息',
    upload_name_hint: '已根据文件名称填入，您可随时修改',
    upload_empty_hint: '添加文件以继续 · 每分钟 1 积分',
    upload_pending_hint: '上传完成后即可开始 · 将使用 {credits} 积分',
    upload_preparing_hint: '正在准备文件…',
    upload_ready_hint: '准备好转写 · 将使用 {credits} 积分',
    upload_failed_hint: '上传失败，请更换或移除文件以继续。',
    upload_start: '开始转写',
    upload_replace: '更换',
    upload_remove: '移除',
    upload_audio: '音频',
    upload_video: '视频',
    upload_duration_minutes: '{minutes} 分钟',
    upload_duration_seconds: '{seconds} 秒',
    upload_status_progress: '上传中 · {percent}%',
    upload_status_complete: '上传完成',
    upload_status_failed: '上传失败',
    upload_transferred: '已上传 {transferred} / {total} {unit}',
    upload_time_left: '约剩 {seconds} 秒',

    desktop_share_title: '共享转写',
    desktop_share_waiting: '等待对话开始…',
    desktop_share_demo: '演示转写',
    desktop_share_ended: '会议已结束。',
    desktop_share_connection_error: '无法连接，正在显示演示数据。',
    desktop_share_invalid: '无效的会话。',
    desktop_field_email: '电子邮箱',
    desktop_field_password: '密码',
    desktop_field_name: '姓名',
    desktop_field_confirm_password: '确认密码',
    desktop_field_verification: '验证码',
    desktop_field_new_password: '新密码',
    desktop_field_invitation: '邀请码',
    theme_dark_mode: '深色模式',
    theme_switch_light: '切换至浅色模式',
    theme_switch_dark: '切换至深色模式',
    home_good_morning: '早上好',
    home_good_afternoon: '下午好',
    home_good_evening: '晚上好',
    home_days_active: '使用天数',
    home_transcribed: '已转写时长',
    home_transcriptions: '次转写',
    home_start_recording: '开始录音',
    home_upload_file: '上传文件',
    home_upload_short: '上传',
    home_record_short: '录音',
    home_transcribe_short: '转写',
    home_live_transcribe: '实时转写',
    home_create_meeting: '创建会议',
    home_recent_meetings: '最近会议',
    home_view_all: '查看全部',
    home_more_actions: '更多操作',
    home_untitled_meeting: '未命名会议',
    home_retry_hint: '可以重试',
    home_summary_ready: '摘要已就绪',
    home_summary_failed: '摘要无法生成',
    home_stats_error: '无法加载统计数据。',
    home_meetings_error: '无法加载会议，请重试。',
    home_empty_title: '从这里开始下一场会议',
    home_empty_description: '录制对话或上传文件，创建您的第一场会议。',
    sidebar_hot_words: '自定义词汇',
    sidebar_all_chat: '对话记录',
    hot_words_title: '自定义词汇',
    desktop_upload_description: '将音频或视频文件转换为逐字稿和会议笔记。',
    desktop_record_description: '录下对话，让我们为您整理笔记。',
    desktop_live_description: '通过实时转写和翻译，跟上每段对话。',
    desktop_not_found_title: '找不到此页面',
    desktop_not_found_description: '请检查网址，或返回您的工作区。',
    desktop_back_home: '返回首页',
  },
};
export default desktopLanguage;
